const jsonLdOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${process.env.NEXT_PUBLIC_HOST || 'https://mypersonality.net'}/#organization`,
  url: `${process.env.NEXT_PUBLIC_HOST || 'https://mypersonality.net'}`,
  logo: 'https://mypersonality.net/logo.svg',
  image: 'https://mypersonality.net/logo.svg',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Beverly Hills, Los Angeles',
    addressRegion: 'California',
    addressCountry: 'US',
    postalCode: '90067',
    streetAddress: '1901 Avenue of the Stars',
  },
  email: 'support@mypersonality.net',
  telephone: '+1 (855) 342-8558',
  name: 'My Personality',
};

export default jsonLdOrganization;
